import { Injectable, TemplateRef } from '@angular/core';

export interface ToastItem {
  textOrTpl: string | TemplateRef<unknown>;
  classname?: string;
  autoHide?: boolean;
  delay?: number;
  header?: string | null;
  error?: boolean;
  message?: string;
  requestId?: string;
  [key: string]: unknown;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  public toasts: ToastItem[] = [];

  public success(message: string | TemplateRef<unknown>, options: Partial<ToastItem> = {}) {
    this.show(message, { classname: 'bg-success', ...options });
  }

  public info(message: string | TemplateRef<unknown>, options: Partial<ToastItem> = {}) {
    this.show(message, { classname: 'bg-info', ...options });
  }

  public warn(message: string | TemplateRef<unknown>, options: Partial<ToastItem> = {}) {
    this.show(message, { classname: 'bg-warning', ...options });
  }

  public warnCenter(message: string | TemplateRef<unknown>, delay: number | null = null) {
    this.show(message, { classname: 'bg-warning center-msg center-msg-vertical', delay: delay ?? undefined });
  }

  public danger(message: string | TemplateRef<unknown>, options: Partial<ToastItem> = {}) {
    this.show(message, { classname: 'bg-danger', ...options });
  }

  public dangerCenter(message: string | TemplateRef<unknown>) {
    this.show(message, { classname: 'bg-danger center-msg' });
  }

  private show(textOrTpl: string | TemplateRef<unknown>, options: Partial<ToastItem> = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  public remove(toast: ToastItem) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}
